// removed by extract-text-webpack-plugin
module.exports = {"flex-point":"_3GnfTjBQ-y6QxIS9tFWbGZ","point-container":"LQEiw3zWJTBOfS6pEMaL-","heart-template":"_1MGg-cKuGNN5cX41MLPUio","star":"_1uxYIyCiQMOjN_Xv-7YOVx _1MGg-cKuGNN5cX41MLPUio","star-h":"_2EwboRMPlhaJ_FWUVMeTaU _1MGg-cKuGNN5cX41MLPUio","star-o":"_2-OCfhm-9VttK3dNCPwXqR _1MGg-cKuGNN5cX41MLPUio"};


//////////////////
// WEBPACK FOOTER
// ./src/components/General/RatingPoint/RatingPoint.scss
// module id = 1164
// module chunks = 47